var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCorrectMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 22,
    viewBox: "0 0 22 22",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_539_291504)"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "#128B38",
    height: 14.9525,
    rx: 7.47627,
    stroke: "#1FBF40",
    strokeWidth: 1.39296,
    width: 14.9525,
    x: 1.88007,
    y: 1.90156
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1866 6.65633C12.3303 6.7841 12.3433 7.00421 12.2155 7.14796L8.50096 11.3268C8.43487 11.4012 8.34015 11.4437 8.24068 11.4437C8.14121 11.4437 8.04648 11.4012 7.9804 11.3268L6.12312 9.2374C5.99535 9.09365 6.00829 8.87354 6.15204 8.74576C6.29579 8.61799 6.5159 8.63094 6.64368 8.77468L8.24068 10.5713L11.695 6.68524C11.8227 6.5415 12.0428 6.52855 12.1866 6.65633Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1866 6.65633C12.3303 6.7841 12.3433 7.00421 12.2155 7.14796L8.50096 11.3268C8.43487 11.4012 8.34015 11.4437 8.24068 11.4437C8.14121 11.4437 8.04648 11.4012 7.9804 11.3268L6.12312 9.2374C5.99535 9.09365 6.00829 8.87354 6.15204 8.74576C6.29579 8.61799 6.5159 8.63094 6.64368 8.77468L8.24068 10.5713L11.695 6.68524C11.8227 6.5415 12.0428 6.52855 12.1866 6.65633Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.928639
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse",
    height: 21.1646,
    id: "filter0_d_539_291504",
    width: 21.1627,
    x: 0.380437,
    y: 0.401921
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    result: "hardAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.60631,
    dy: 1.60631
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.20474
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    mode: "normal",
    result: "effect1_dropShadow_539_291504"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_539_291504",
    mode: "normal",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrectMark);
export default __webpack_public_path__ + "static/media/correct-mark.637abc227d6a362576da999af3c7a93f.svg";
export { ForwardRef as ReactComponent };